import { APPROVE_BILLS_REQUEST, APPROVE_BILLS_SUCCESS, APPROVE_BILLS_FAIL,
    REJECT_BILLS_REQUEST, REJECT_BILLS_SUCCESS, REJECT_BILLS_FAIL,
    APPROVE_PAYMENTS_REQUEST, APPROVE_PAYMENTS_SUCCESS, APPROVE_PAYMENTS_FAIL,
    REJECT_PAYMENTS_REQUEST, REJECT_PAYMENTS_SUCCESS, REJECT_PAYMENTS_FAIL  } from "../types/approvalTypes";

function approveBillsReducer( state = { approveBills: []}, action) {
    switch (action.type) {
        case APPROVE_BILLS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case APPROVE_BILLS_SUCCESS:
            return {
                ...state,
                approveBills: action.payload,
                isLoading: false
            }       
        case APPROVE_BILLS_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function rejectBillsReducer( state = { rejectBills: []}, action) {
    switch (action.type) {
        case REJECT_BILLS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case REJECT_BILLS_SUCCESS:
            return {
                ...state,
                rejectBills: action.payload,
                isLoading: false
            }       
        case REJECT_BILLS_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function approvePaymentsReducer( state = { approvePayments: []}, action) {
    switch (action.type) {
        case APPROVE_PAYMENTS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case APPROVE_PAYMENTS_SUCCESS:
            return {
                ...state,
                approvePayments: action.payload,
                isLoading: false
            }       
        case APPROVE_PAYMENTS_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function rejectPaymentsReducer( state = { rejectPayments: []}, action) {
    switch (action.type) {
        case REJECT_PAYMENTS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case REJECT_PAYMENTS_SUCCESS:
            return {
                ...state,
                rejectPayments: action.payload,
                isLoading: false
            }       
        case REJECT_PAYMENTS_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { approveBillsReducer, rejectBillsReducer, approvePaymentsReducer, rejectPaymentsReducer }